export const ru = {
    new_group_title: 'Новая группа пользователей',
};
